// @ngInject
function dashboard(DashboardApiService, $debounce) {
  return {
    templateUrl: 'directives/dashboard/dashboard.tpl.html',
    link: function($scope) {
      $scope.addNewWidget = function(widget) {
        var newWidget = angular.copy(widget);
        $scope.widgets.push(newWidget);
      };
      
      $scope.gridsterOpts = {
        columns: 24,
        margins: [5, 5],
        outerMargin: true,
        pushing: true,
        floating: true,
        swapping: true,
        mobileBreakPoint: 500,
        resizable: {
          enabled: true,
          handles: ['e', 's', 'se'],
          start: function(event, $element, widget) {},  // optional callback fired when resize is started,
          resize: function(event, $element, widget) {}, // optional callback fired when item is resized,
          stop: function(event, $element, widget) {}    // optional callback fired when item is finished resizing
        },
        draggable: {
          enabled: true, // whether dragging items is supported
          handle: '.wgt-heading',
          start: function(event, $element, widget) {},  // optional callback fired when drag is started,
          drag: function(event, $element, widget) {},   // optional callback fired when item is moved,
          stop: function(event, $element, widget) {}    // optional callback fired when item is finished dragging
        }
      };

      $scope.$watch('widgets', function() {
        $debounce($scope.saveDashboard, 2500);
      }, true);
      $scope.saveDashboard = function() {
        DashboardApiService.saveWidgets($scope.widgets)
          .then(function(response) {
          });
      };

    }
  };
}

angular
  .module('directives.dashboard', [])
  .directive('dashboard', ['DashboardApiService', '$debounce', dashboard])
  .filter('cmdate', [
    '$filter',
    function($filter) {
      return function(input, format) {
        return $filter('date')(new Date(input.replace(new RegExp('-', 'g'), '/')), format); // replace is used for IE to understand the date
      };
    }
  ])
  .factory('$debounce', ['$rootScope', '$browser', '$q', '$exceptionHandler',
    function($rootScope, $browser, $q, $exceptionHandler) {
      var deferreds = {},
        methods = {},
        uuid = 0;

      function debounce(fn, delay, invokeApply) {
        var deferred = $q.defer(),
          promise = deferred.promise,
          skipApply = (angular.isDefined(invokeApply) && !invokeApply),
          timeoutId, cleanup,
          methodId, bouncing = false;

        // check we dont have this method already registered
        angular.forEach(methods, function(value, key) {
          if (angular.equals(methods[key].fn, fn)) {
            bouncing = true;
            methodId = key;
          }
        });

        // not bouncing, then register new instance
        if (!bouncing) {
          methodId = uuid++;
          methods[methodId] = {
            fn: fn
          };
        } else {
          // clear the old timeout
          deferreds[methods[methodId].timeoutId].reject('bounced');
          $browser.defer.cancel(methods[methodId].timeoutId);
        }

        var debounced = function() {
          // actually executing? clean method bank
          delete methods[methodId];

          try {
            deferred.resolve(fn());
          } catch (e) {
            deferred.reject(e);
            $exceptionHandler(e);
          }

          if (!skipApply) {
            $rootScope.$apply();
          }
        };

        timeoutId = $browser.defer(debounced, delay);

        // track id with method
        methods[methodId].timeoutId = timeoutId;

        cleanup = function(reason) {
          delete deferreds[promise.$$timeoutId];
        };

        promise.$$timeoutId = timeoutId;
        deferreds[timeoutId] = deferred;
        promise.then(cleanup, cleanup);

        return promise;
      }

      // similar to angular's $timeout cancel
      debounce.cancel = function(promise) {
        if (promise && promise.$$timeoutId in deferreds) {
          deferreds[promise.$$timeoutId].reject('canceled');
          return $browser.defer.cancel(promise.$$timeoutId);
        }
        return false;
      };

      return debounce;
    }
  ]);
